import {Prepaid} from '@/app/prepaid/prepaid-routes';
import {usePaymentStatusStore_toBeRemoved} from '@/app/shared/state/PaymentStatusModule';
import {computed, defineComponent, onMounted, ref, watch} from 'vue';
import {useRouter} from '@/router/router-vue3';
import {useFeatureToggleStore} from "@/stores/feature-toggle-store";
import {useFormatting} from "@/composables/formatting";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlCheckoutPaymentMethod',
    emits: ['updatePaymentMethod'],
    props: {
        prepaidSaldo: {type: Number, required: true},
        prepaidTreshold: {type: Number, required: true},
        isPrepaidUploaded: {type: Boolean, required: true},
    },
    setup(props, {emit}) {

        const router = useRouter();
        const paymentMethod = ref<string>('');
        const {formatCurrency} = useFormatting();

        const prepaidDisabled = computed(() => {
            return !userHadPrepaidBefore.value || !isPrepaidSufficient.value;
        });

        const userHadPrepaidBefore = computed(() => {
            return props.isPrepaidUploaded;
        });

        const isPrepaidSufficient = computed(() => {
            return props.prepaidTreshold !== 0 && props.prepaidSaldo >= props.prepaidTreshold;
        });

        const prepaidDeficiency = computed(() => {
            if (!isPrepaidSufficient.value) {
                return Number((props.prepaidTreshold - props.prepaidSaldo).toFixed(2));
            }
            return undefined;
        });

        const routePrepaid = computed(() => {
            return Prepaid;
        });


        const addPrepaid = () => {
            usePaymentStatusStore_toBeRemoved().setPrepaidAmount(prepaidDeficiency.value);
            router.push({name: Prepaid.name});
        }

        watch(
            paymentMethod,
            (newPaymentMethod: string) => {
                emit('updatePaymentMethod', newPaymentMethod);
            },
            {immediate: false, deep: true});


        onMounted(() => {
            paymentMethod.value = isPrepaidSufficient.value ? (!paymentMethod.value ? 'prepaid' : paymentMethod.value) : 'card';
        });


        return {
            paymentMethod,
            prepaidDisabled,
            userHadPrepaidBefore,
            isPrepaidSufficient,
            prepaidDeficiency,
            routePrepaid,
            formatCurrency,
            addPrepaid,
        }
    }
});
